import { render, staticRenderFns } from "./MediaPlanEdit.vue?vue&type=template&id=1224fb1c&"
import script from "./MediaPlanEdit.vue?vue&type=script&lang=ts&"
export * from "./MediaPlanEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MediaPlanEdit.vue?vue&type=style&index=0&id=1224fb1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports